'use client';
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';

export interface IVideoPlayerHandle {
  openFullscreen(): void;
  play(): void;
  pause(): void;
}

export interface IVideoPlayerProps {
  onAutoPlayStarted?: () => void;
  onPayerReady?: () => void;
  media: any;
  cover?: boolean;
  controls?: boolean;
  muted?: boolean;
}

const VideoPlayer = forwardRef(function VideoPlayer(
  { media, cover, onAutoPlayStarted, muted, ...props }: IVideoPlayerProps,
  ref,
) {
  const player = useRef<HTMLVideoElement>(null);

  useImperativeHandle(ref, () => {
    return {
      openFullscreen() {
        if ((media.allowFullScreen === undefined || media.allowFullScreen === true) && player.current) {
          if (player.current.requestFullscreen) {
            player.current.requestFullscreen();
          }
          player.current.play();
        }
      },
      play() {
        player.current?.play();
      },
      pause() {
        player.current?.pause();
      },
    };
  }, [media]);

  const onPlay = () => {
    if (media.autoPlay && onAutoPlayStarted) {
      onAutoPlayStarted();
    }
  };

  if (!media) {
    return null;
  }

  return (
    <video
      className={classNames('video absolute left-0 top-0 h-full w-full', cover && 'object-cover')}
      ref={player}
      autoPlay={media.autoPlay}
      muted={media.autoPlay ? true : muted}
      loop={media.loop}
      onPlay={onPlay}
      {...props}
    >
      <source src={media.videoFromGallery} type="video/mp4" />
      Your browser does not support HTML5 video.
    </video>
  );
});

export default VideoPlayer;
